<template>
    <wrapper-edit
            @back="paasPageBack"
            wTitle="添加特惠商品" >
        <div slot="form" v-height="{offsetHeight:110}">
            <div class="layout">
                <Layout class="product-layout">
                    <Sider :width="330"
                           v-model="isCollapsed"
                           class="product-sider">
                        <div ref="listWrap">
                            <Row class="header-row">
                                <Input suffix="ios-search"
                                       placeholder="快速搜索商品名称、货号"
                                       v-model="productQuery.keyword"
                                       @on-change="searchProducts"
                                       style="width: 130px" />
                                &nbsp;&nbsp;
                                <Checkbox v-model="productQuery.isSearchExist"
                                          @on-change="searchProducts">隐藏已参加本活动的宝贝</Checkbox>
                            </Row>
                        </div>
                        <Table border
                               :height="tableHeight"
                               ref="productSelection"
                               :columns="productColumns"
                               :data="productData"></Table>

                    </Sider>
                    <Content class="product-content">
                        <Table border
                               :height="discountHeight"
                               ref="discountSelection"
                               :columns="discountColumns"
                               @on-selection-change="changeDiscountSelection"
                               :data="discountData"></Table>
                        <Row class="checkFooter">
                            <Col span="2">
                                <span class="checktext">已选&nbsp;{{checkNum}}</span>
                            </Col>
                            <Col span="5">
                                <Input v-model="allDiscount" @on-blur="updateMultiDiscount('discountPercent')">
                                    <span slot="prepend">打</span>
                                    <span slot="append">折</span>
                                </Input>
                            </Col>
                            <Col span="5">
                                <Input v-model="allDeducePrice" @on-blur="updateMultiDiscount('reducePrice')">
                                    <span slot="prepend">减</span>
                                    <span slot="append">元</span>
                                </Input>
                            </Col>
                            <Col span="5">
                                <Input v-model="allDiscountPrice" @on-blur="updateMultiDiscount('discountPrice')">
                                    <span slot="prepend">减价后</span>
                                    <span slot="append">元</span>
                                </Input>
                            </Col>
                            <Col span="7">
                                <Button type="primary" size="default" @click="batchActive"><Icon type="ios-barcode"></Icon> 批量加入活动</Button>
                                &nbsp;
                                <Button type="primary" size="default" @click="batchDelete"><Icon type="ios-trash"></Icon> 批量删除</Button>
                            </Col>
                        </Row>

                    </Content>
                </Layout>
            </div>
        </div>
    </wrapper-edit>
</template>

<script>
    import wrapperEdit from "@/components/paas/wrapper-edit";
    import {getProductsByKeyword,getDiscountProducts,addDiscountProduct,updateDiscountProductsPrice,
        updateMultDiscountProductsPrice,saveIsActiveData,deleteLogicDiscountProduct,batchSaveIsActiveData} from "@api/store.js";
    import CellBar from '@/components/paas/cell-bar'; //列表内操作
    import {mul,div,sub,keepTwoDecimal} from '@utils/util.js';
    export default {
        name: "productAdd",
        components:{wrapperEdit,CellBar},
        data() {
            return{
                serviceUrl:"/eb/store/product/discount",
                isCollapsed: false,
                fkaDiscountId:"",
                productColumns:[
                    {
                        title: '商品数据',
                        key: 'image',
                        render:(h,params)=>{
                            return h("div",{
                                style:{
                                    display:"flex",
                                    flexFlow: "row nowrap",
                                    justifyContent:"space-between"
                                }
                            },[
                                h('img',{
                                    attrs: {
                                        src: params.row.image,
                                    },
                                    style:{
                                        width:"80px",
                                        height:"80px",
                                        margin:"5px auto",
                                    }
                                }),
                                h("div",{
                                    style:{
                                        margin:"2px 5px",
                                        lineHeight:"20px"
                                    }
                                },[
                                    h('p',{
                                        style:{
                                            fontSize:"12px",
                                            color:"black",
                                        }
                                    },params.row.name),
                                    h('p',{
                                        style:{
                                            fontSize:"12px",
                                            marginTop:"4px",

                                        }
                                    },[
                                        h('span',{
                                            style:{
                                                fontWeight:"bold"
                                            }
                                        },"吊牌价:"),
                                        h("span",{},params.row.price+"元")
                                    ])
                                ])
                            ])
                        }
                    },
                    {
                        title: '操作',
                        width:70,
                        render: (h, params) => {
                            return  h('Button',{
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                    icon:"md-add"
                                },
                                on: {
                                    click: () => {
                                        this.addDiscountProduct(params);
                                    }
                                }
                            });
                        }
                    },
                ],
                productData:[],
                productQuery:{
                    keyword:"", //商品名称 or  货号
                    isSearchExist:false, //是否隐藏已参加本活动的宝贝
                    discountId:""
                },
                discountColumns:[
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '折扣商品信息',
                        key: 'discountImg',
                        width:300,
                        render:(h,params)=>{
                            return h("div",{
                                style:{
                                    display:"flex",
                                    flexFlow: "row nowrap",
                                    justifyContent:"space-between"
                                }
                            },[
                                h('img',{
                                    attrs: {
                                        src: params.row.discountImg,
                                    },
                                    style:{
                                        width:"80px",
                                        height:"80px",
                                        margin:"5px auto",
                                    }
                                }),
                                h("div",{
                                    style:{
                                        margin:"2px 5px",
                                        lineHeight:"20px"
                                    }
                                },[
                                    h('p',{
                                        style:{
                                            fontSize:"12px",
                                            color:"black",
                                        }
                                    },params.row.productName),
                                    h('p',{
                                        style:{
                                            fontSize:"12px",
                                            marginTop:"4px",

                                        }
                                    },[
                                        h('span',{
                                            style:{
                                                fontWeight:"bold"
                                            }
                                        },"吊牌价:"),
                                        h("span",{},params.row.price+"元")
                                    ])
                                ])
                            ])
                        }
                    },
                    {
                        title: '折扣',
                        key: 'discountPercent',
                        width:140,
                        render:(h,params)=>{
                            return h ("Tooltip",{
                                props: {
                                    placement: 'top',
                                    transfer: true
                                }
                            },[//这个中括号表示是Tooltip标签的子标签
                                h("Input",{
                                    props:{
                                        value:params.row.discountPercent,
                                        autosize: true
                                    },
                                    on:{
                                        'on-blur': (event) => {
                                            let discountValue = event.target.value;
                                            //折扣的规则大于0 小于10
                                            if(parseFloat(discountValue) <= 0){
                                                this.$Message.error("折扣不能小于等于0");
                                            }else if(parseFloat(discountValue) > 10){
                                                this.$Message.error("折扣不能大于10");
                                            }else{
                                                //计算减价和特惠价
                                                //市场价
                                                let marcketPrice = params.row.price;
                                                //折扣率
                                                let discountRate = div(parseFloat(discountValue),10);
                                                //特惠价
                                                let specialPrice = parseInt(mul(parseFloat(marcketPrice),parseFloat(discountRate)));
                                                //减了多少钱
                                                let reducePrice = parseInt(sub(parseFloat(marcketPrice),parseFloat(specialPrice)));
                                                this.changeDiscountPrice(params.row.id,discountValue,specialPrice,reducePrice);
                                            }

                                        }
                                    }
                                },[
                                    h('span',{
                                        slot:"prepend"
                                    },"打"),
                                    h('span',{
                                        slot:"append"
                                    },"折"),
                                ]),
                                h('div', {
                                    slot: 'content',
                                    style:{
                                        whiteSpace:"normal"
                                    }
                                },"打折的计算公式:商品原价×折扣率=商品折扣后价格")
                            ])
                        }
                    },
                    {
                        title: '减价',
                        key: 'reducePrice',
                        width:150,
                        render:(h,params)=>{
                            return h ("Tooltip",{
                                props: {
                                    placement: 'top',
                                    transfer: true
                                }
                            },[//这个中括号表示是Tooltip标签的子标签
                                h("Input",{
                                    props:{
                                        value:params.row.reducePrice,
                                        autosize: true
                                    },
                                    on:{
                                        'on-blur': (event) => {
                                            let reducePrice = event.target.value;
                                            //市场价
                                            let marcketPrice = params.row.price;
                                            if(reducePrice < 0){
                                                this.$Message.error("减价不能小于0");
                                            }else if(reducePrice > marcketPrice){
                                                this.$Message.error("减价不能超过市场价");
                                            }else{
                                                //计算折扣和特惠价
                                                //特惠价
                                                let specialPrice = parseInt(sub(parseFloat(marcketPrice),parseFloat(reducePrice)));
                                                //折扣率
                                                let discountRate = keepTwoDecimal(div(parseFloat(specialPrice),parseFloat(marcketPrice)));
                                                let discountValue = mul(parseFloat(discountRate),10);
                                                this.changeDiscountPrice(params.row.id,discountValue,specialPrice,reducePrice);
                                            }
                                        }
                                    }
                                },[
                                    h('span',{
                                        slot:"prepend"
                                    },"减"),
                                    h('span',{
                                        slot:"append"
                                    },"元"),
                                ]),
                                h('div', {
                                    slot: 'content',
                                    style:{
                                        whiteSpace:"normal"
                                    }
                                },"减价不能是负数")
                            ]);

                        }
                    },
                    {
                        title: '特惠价',
                        key: 'discountPrice',
                        width:180,
                        render:(h,params)=>{
                            return h ("Tooltip",{
                                props: {
                                    placement: 'top',
                                    transfer: true
                                }
                            },[//这个中括号表示是Tooltip标签的子标签
                                h("Input",{
                                    props:{
                                        value:params.row.discountPrice,
                                        autosize: true
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            let discountPrice = event.target.value;
                                            //市场价
                                            let marcketPrice = params.row.price;
                                            if(discountPrice < 0){
                                                this.$Message.error("特惠价不能小于0");
                                            }else if(discountPrice > marcketPrice){
                                                this.$Message.error("特惠价不能超过市场价");
                                            }else{
                                                //计算折扣和减价
                                                //减了多少钱
                                                let reducePrice = parseInt(sub(parseFloat(marcketPrice),parseFloat(discountPrice)));
                                                //折扣率
                                                let discountRate = keepTwoDecimal(div(parseFloat(discountPrice),parseFloat(marcketPrice)));
                                                let discountValue = mul(parseFloat(discountRate),10);

                                                this.changeDiscountPrice(params.row.id,discountValue,discountPrice,reducePrice);
                                            }

                                        }
                                    }
                                },[
                                    h('span',{
                                        slot:"prepend"
                                    },"减价后"),
                                    h('span',{
                                        slot:"append"
                                    },"元"),
                                ]),
                                h('div', {
                                    slot: 'content',
                                    style:{
                                        whiteSpace:"normal"
                                    }
                                },"特惠价不能为负数")
                            ])
                        }
                    },
                    {
                        title: '加入活动',
                        key: 'isActive',
                        width:100,
                        render:(h,params)=>{
                            return h('i-switch', {
                                class:"sale-status",
                                props:{
                                    type: 'primary',
                                    size:'large',
                                    value: params.row.isActive,  //控制开关的打开或关闭状态，官网文档属性是value
                                    'true-value': "1",
                                    'false-value':"0",
                                },
                                on: {
                                    'on-change': (value) => {
                                        params.row.isActive = value;
                                        //实时保存数据
                                        this.saveIsActiveData(params.row);
                                    }
                                }
                            },[
                                h('span', {
                                    slot: 'open',
                                    domProps: {
                                        innerHTML: '加入'
                                    }
                                }),
                                h('span', {
                                    slot: 'close',
                                    domProps: {
                                        innerHTML: '未加'
                                    }
                                }),
                            ])
                        }
                    },
                    {
                        title: '操作',
                        width:90,
                        render: (h, params) => {
                            return  h('Button',{
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.deleteLogicDiscountProduct(params.row.id);
                                    }
                                }
                            },"删除");
                        }
                    }
                ],
                discountData:[],
                checkNum:0 , //已选商品
                checkSelection:[],
                checkDiscountIds:"",
                allDiscount:"", //折扣
                allDeducePrice:"", //减多少元
                allDiscountPrice:"", //特惠价
                tableHeight:0,
                discountHeight:0,
            }
        },
        created(){
            //;
            //获取特惠活动id
            let updateData = this.$route.params.updateData;
            this.fkaDiscountId = updateData[0].id;
            this.productQuery.discountId = updateData[0].id;
            this.getDiscountProducts();
        },
        mounted(){
            this.$nextTick(() => {
                this.calculateTableHeight();
            })
        },
        methods:{
            clearSelection(){
                this.checkNum=0 ; //已选商品
                this.checkSelection=[];
                this.checkDiscountIds="";
            },
            /**
             * 计算table的高度
             * @param flag
             */
            calculateTableHeight(flag){
                let docHeight = document.documentElement.clientHeight; //可见区域的高度
                /**
                 * 只能是元组件才有的方法
                 * 距离父组件的高度
                 * @type {number}
                 */
                let queryOffsetTop = 0;
                if(this.$refs.listWrap){
                    queryOffsetTop = this.$refs.listWrap.getBoundingClientRect().top;
                }

                let queryHeight = 0;
                if(flag || typeof(flag) === 'undefined'){
                    /**
                     * 当前组件的高度，非元组件
                     * @type {number}
                     */
                    if(typeof(this.$refs.productSelection) !== "undefined"){
                        queryHeight = this.$refs.productSelection.$el.clientHeight;
                    }
                }
                this.tableHeight = docHeight - queryOffsetTop - queryHeight;
                this.discountHeight = docHeight - queryOffsetTop - queryHeight-10;
            },
            /**
             * 加入特惠
             * */
            addDiscountProduct(param){
                let productParam = {
                    productId:param.row.id,
                    id:this.fkaDiscountId
                };
                addDiscountProduct(productParam).then(res => {
                    this.discountData.push(res.data);

                })
            },
            /**
             * 根据搜索的关键词查询table数据
             */
            searchProducts(){
                getProductsByKeyword(this.productQuery).then(res=>{
                    if(res.code === 200){
                        this.productData = res.data;
                    }
                })
            },
            /**
             * 获取特惠商品
             * */
            getDiscountProducts(){
                getDiscountProducts(this.fkaDiscountId).then(res=>{
                    if(res.code === 200){
                        this.discountData = res.data;
                    }
                })
            },
            /**
             * 点击关闭逻辑，一般默认跳转list路由页面
             * @param event
             * @param url
             */
            paasPageBack(event, url){
               // ;
                if(!url) {
                    url = this.serviceUrl+"/list";
                }
                this.$router.push({'path': this.setUrlFuncId(url)});
            },
            /**
             * url添加功能ID参数,封装这个方法是以防功能配置也有传参数
             * */
            setUrlFuncId(url) {
                if(url.indexOf("?") !== -1) {
                    url += '&';
                } else {
                    url += '?';
                }
                //组装paasCurrentFunctionId=***
                url += this.$store.state.funcIdName+'='+this.$route.query[this.$store.state.funcIdName];
                return url;
            },
            /**
             * 保存折扣数据
             * @param id
             * @param discountValue
             * @param specialPrice
             * @param reducePrice
             */
            changeDiscountPrice(id,discountValue,specialPrice,reducePrice){
                //更新discountData第index数据
                let param = {
                    id:id,
                    discountPercent:discountValue,
                    discountPrice:specialPrice,
                    reducePrice:reducePrice
                }
                updateDiscountProductsPrice(param).then(res=>{
                    let newDiscountProducts = [];
                    for(let i = 0; i < this.discountData.length; i++){
                        if(id === this.discountData[i].id){
                            this.discountData[i].discountPercent = discountValue;
                            this.discountData[i].discountPrice = specialPrice;
                            this.discountData[i].reducePrice = reducePrice;
                        }
                        newDiscountProducts.push(this.discountData[i]);
                    }
                    this.discountData = newDiscountProducts;
                })
            },
            /**
             * 选中项发生变化时就会触发
             * @param selection
             */
            changeDiscountSelection(selection){
                this.checkSelection = selection;
                this.checkNum = selection.length;
                let ids = "";
                for(let i = 0; i < selection.length; i++){
                    ids += selection[i].id;
                    if(i != selection.length-1){
                        ids += ",";
                    }
                }
                this.checkDiscountIds = ids;
            },
            /**
             * 批量 多选 更新特惠
             * @param item
             */
            updateMultiDiscount(type){
                if(this.checkSelection.length > 0){
                    let val = "";
                    if(type === "discountPercent"){
                        val = this.allDiscount;
                    }else if(type === "reducePrice"){
                        val = this.allDeducePrice;
                    }else if(type === "discountPrice"){
                        val = this.allDiscountPrice;
                    }

                    let params = {
                        ids:this.checkDiscountIds,
                        type:type,
                        value:val
                    }
                    updateMultDiscountProductsPrice(params).then(res=>{
                        let data = res.data;
                        let newDiscountProducts = [];
                        for(let i = 0; i < this.discountData.length; i++){
                            let discount = this.discountData[i];
                            for(let j = 0; j < data.length; j++){
                                if(this.discountData[i].id === data[j].id){
                                    discount = data[j];
                                    break;
                                }
                            }
                            newDiscountProducts.push(discount);
                        }
                        this.discountData = newDiscountProducts;
                        this.clearSelection();
                        //this.getDiscountProducts();
                    })
                }
                else{
                   this.$Message.error("请先选中特惠商品");
                }
            },
            /**
             * 是否参加活动
             * @param row
             */
            saveIsActiveData(row){
                let param = {
                    id:row.id,
                    isActive:row.isActive
                }
                saveIsActiveData(param).then(res=>{
                    if(res.code == 200){
                        this.$Message.info('数据更新成功！');
                    }
                }).catch(function(error){
                    this.$Message.error('数据更新失败！');
                });
            },
            /**
             * 逻辑移除特惠商品
             * @param id
             */
            deleteLogicDiscountProduct(id){
                deleteLogicDiscountProduct(id).then(res=>{
                    for(let i = 0; i < this.discountData.length; i++){
                        if(id === this.discountData[i].id){
                            this.discountData.splice(i,1);
                            break;
                        }
                    }
                })
            },
            //批量加入活动
            batchActive(){
                let ids  = this.checkDiscountIds;
                batchSaveIsActiveData(ids).then(res =>{
                    if(res.code == 200){
                        this.getDiscountProducts();
                        this.clearSelection();
                    }
                })
            },
            /**
             * 批量删除
             */
            batchDelete(){
                let ids  = this.checkDiscountIds;
                let idArr = ids.split(",");
                deleteLogicDiscountProduct(ids).then(res=>{
                    //用逆向循环
                    for(let i = this.discountData.length-1; i >= 0 ; i--){
                        for(let j = 0; j < idArr.length; j++){
                            if(this.discountData[i].id === idArr[j]){
                                this.discountData.splice(i,1);
                                break;
                            }
                        }
                    }
                    this.clearSelection();
                })
            }
        }
    }
</script>

<style scoped>
    .layout-con{
        height: 100%;
        width: 100%;
    }
    .product-layout{
        height:100%;
    }
    .product-sider{
        border: 1px solid #eee;
        border-radius: 6px;
        background-color: #fff;
        height:100%;
    }
    .product-sider:hover{
        box-shadow: 0 2px 7px rgba(0,0,0,.15);
        border-color: transparent;
    }
    .product-content{
        border: 1px solid #eee;
        border-radius: 6px;
        background-color: #fff;
    }
    .header-row{
        padding:5px;
    }
    .menu-item span{
        display: inline-block;
        overflow: hidden;
        width: 69px;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
        transition: width .2s ease .2s;
    }
    .menu-item i{
        transform: translateX(0px);
        transition: font-size .2s ease, transform .2s ease;
        vertical-align: middle;
        font-size: 16px;
    }
    .collapsed-menu span{
        width: 0;
        transition: width .2s ease;
    }
    .collapsed-menu i{
        transform: translateX(5px);
        transition: font-size .2s ease .2s, transform .2s ease .2s;
        vertical-align: middle;
        font-size: 22px;
    }
    .checkFooter{
        background: #fff;
        padding:6px;
    }
    .checkFooter >>> .ivu-input-wrapper{
        width:150px;
    }
    .checktext{
        height:40px;
        line-height:40px;
    }
</style>
